import request from '@/utils/request';
import { stringify } from 'qs';

//错题列表
// export async function wrongList(params: any): Promise<any> {
//   return request(`/api/v1/pb/questions/wrong/${params.id}`);
// }

export async function listApi(params: any): Promise<any> {
  return request(`/api/v1/pb/records?${stringify(params)}`);
}
